/*
THIS COMPONENT IS INCLUDED IN FORM-EDIT ORDER PAGE
 -----------------------------------------*/
import VariantsCounter from '../../../js/components/VariantsCounter.js';
import {isArrayContains} from '../../../js/functions';

import('treed');

let OrderDetail = (() => {

    let offersUrl, orderItemsContainer, discountsContainer, domainsContainer, totalOrderInfoContainer, bonusesContainer, customerAddressContainer;

    let construct = () => {
        offersUrl = '/shop/orders/order_items';
        orderItemsContainer =  $('#order_items_list');
        discountsContainer = $('#discounts_list');
        domainsContainer = $('#order_domains_list');
        totalOrderInfoContainer = $('#info-container');
        bonusesContainer = $('#bonuses_list');
        customerAddressContainer = $('#customer_address');

    };

    //Returns current checked domain
    let getCurrentDomain = function() {
        if ($('.b-admin-orders__domains-list').length) {
            return $('input[name="domain_id"]:checked').val();
        }

        return $('input[name="domain_id"]').val();
    };

    // Returns selected payment type value
    let getSelectedPaymentType = function() {
        return $(document).find('#order_payment_select option:selected').val();
    };

    // Returns selected delivery type value
    let getSelectedDeliveryType = function() {
        return $(document).find('#order_delivery_select option:selected').val();
    };
    let getSelectedDeliveryTariff = function() {
        return $(document).find('#order_delivery_tariff_select option:selected').val();
    };

    // merging popup and at page lists of choosed offers
    let getOrderItemsList = function() {
        let currentOrderItems = getCurrentOrderItems();
        return $.merge(currentOrderItems, getCheckedProducts(currentOrderItems));
    };


    let getCurrentOrderItems = function() {
        return $('#order_items_list').find('tr').map(function () {
            return {
                id: $(this).data('variant'),
                quantity: $(this).find('.b-order__offer-quantity__input').val()
            };
        }).get();
    };

    // get all checked product's variants
    let getCheckedProducts = function(orderItems) {
        return $('#popup_product_tree').find('.variant-checkbox__selected').map(function () {
            if (!isArrayContains('id', this.value, orderItems)) {
                return {
                    id: this.value,
                    quantity: 1
                };
            }
        }).get();
    };

    let getUser = function() {
        return $('#user_id').val();
    };

    let getExtraDiscountValue = function()
    {
        return {
            type: totalOrderInfoContainer.find('.b-extra_discount__type').val(),
            value: totalOrderInfoContainer.find('.b-extra_discount__input').val()
        };
    };

    let getOrderId = function () {
        return $('#order_id').val();
    };

    let getWallet = function () {
        return $(document).find('#wallet').val();
    };

    let clearWallet = function () {
        $(document).find('#wallet').val('');
    };

    let getLocation = function () {
        return $(document).find("#location").val();
    };

    let getLastName = function () {
        return $(document).find("#lastname").val();
    };

    let getFirstName = function () {
        return $(document).find("#firstname").val();
    };

    let getEmail = function() {
        return $(document).find("#email").val();
    };


    let getSublocation = function() {
        return $(document).find("#sub_location").val();
    };

    let getSublocationId = function() {
        return $(document).find("#sub_location_id").val();
    };


    let getCity = function() {
        return $(document).find("#city").val();
    };


    let getPostCode = function () {
        return $(document).find("#postcode").val();
    };

    let getAddress = function () {
        return $(document).find("#address").val();

    };

    let setActiveVariants = function() {
        orderItemsContainer.find('tr').each(function() {
            let variantId = $(this).data('variant');
            $('#popup_product_tree').find('#variant_id_' + variantId).prop('checked', true);
        });
    };

    let getPackage = function () {
        return $(document).find("#package_id option:selected").val();
    };

    let getPackagingPrice = function () {
        return $(document).find("#packaging_price").val();
    };

    let getStatusId = () => {
        return $(document).find("#status_id option:selected").val();
    };

    let getPromoCodeId =  () => {
        return $(document).find("#promo_code").text();
    };

    let returnedStatusCode = 'return';

    let selectedReturnedStatus = function (statusCode) {
        return statusCode === returnedStatusCode;
    };


    let listenLocationChange = function () {
        $(document).on('change', '#location, #sub_location_id', updateOrderInformation);
    };


    let listenOfferRemove = function () {
        $(document).on('click', '.b-order__offer-remove', function() {
            let parentContainer = $(this).parents('tr');
            let variantId = parentContainer.data('variant');
            $('#variant_id_' + variantId).prop("checked", false);
            $('#variant_id_' + variantId).attr("class", "b-products-tree__variant-checkbox");
            parentContainer.remove();
            updateOrderInformation();
        });
    };

    let listenProductSelectedInPopup = function () {
        $(document).on('click', '#apply_order_products_popup', updateOrderInformation);
    };


    let listenExtraDiscountChange = function () {
        totalOrderInfoContainer.on('change', '.b-extra_discount__input', updateOrderInformation);
    };

    let listenChangeDeliveryType = function () {
        totalOrderInfoContainer.on('change', '#order_delivery_select', function () {
            updateOrderInformation();
            onUpdateDeliveryTypeChangeToFirstDeliveryTariff();
        });
    };
    let onUpdateDeliveryTypeChangeToFirstDeliveryTariff = function ()  {
        let observer = new MutationObserver((mutations) => {
            mutations.forEach(function(mutation) {
                if (mutation.addedNodes.length) {
                    $("#order_delivery_tariff_select").val($("#order_delivery_tariff_select option:first").val());
                    updateOrderInformation();
                    observer.disconnect();
                }
            });
        });
    
        observer.observe(document.querySelector('#info-container'), {
            childList: true,
            subtree: true,
            characterDataOldValue: false
        });
    };
    
    let listenChangeDeliveryTariff = function () {
        totalOrderInfoContainer.on('change', '#order_delivery_tariff_select', updateOrderInformation);
    };

    let listenChangePaymentType = function () {
        totalOrderInfoContainer.on('change', '#order_payment_select', function() {
            clearWallet();
            updateOrderInformation();
        });
    };

    let listenChangeOfferQuantity = function () {
        orderItemsContainer.on('change', '.b-order__offer-quantity__input', function() {
            VariantsCounter.validate(this);
            updateOrderInformation();
        });
    };

    let listenChangeExtraDiscountType = function () {
        totalOrderInfoContainer.on('change', '.b-extra_discount__type', function () {
            let discountValue = $('.b-extra_discount__input').val();
            if (discountValue !== 0) {
                updateOrderInformation();
            }
        });
    };

    let listenVariantCheckBox = function () {
        $(document).on('click', '.b-products-tree__variant-checkbox', function() {
            $(this).toggleClass('variant-checkbox__selected');
        });
    };

    let listenOrderSubmitButton = function () {
        $('#order_admin_form').submit(function () {
            let chosenStatusCode = $('#status_id').find(':selected').data('code');
            if (selectedReturnedStatus(chosenStatusCode)) {
                return confirm("Внимание, ручной перевод заказа в статус 'Возврат' не вернет товары из него на склад!" +
                    " Чтобы товары вернулись, отмените это действие и воспользуйтесь формой в меню Склад->Возврат. ");
            }
        });
    };

    // load products list to main form using ajax
    let updateOrderInformation = function() {
        $.ajax({
            url: offersUrl,
            type: 'POST',
            dataType: 'json',
            data: {
                variants: getOrderItemsList(),
                domain_id: getCurrentDomain(),
                delivery_type_id: getSelectedDeliveryType(),
                delivery_tariff_id: getSelectedDeliveryTariff(),
                payment_type_id: getSelectedPaymentType(),
                extraDiscount: getExtraDiscountValue(),
                user_id: getUser(),
                order_id: getOrderId(),
                wallet: getWallet(),
                location_id: getLocation(),
                sub_location: getSublocation(),
                city: getCity,
                sub_location_id: getSublocationId(),
                lastname: getLastName(),
                firstname: getFirstName(),
                email: getEmail(),
                postcode: getPostCode(),
                address: getAddress(),
                package_id: getPackage(),
                packaging_price: getPackagingPrice(),
                status_id: getStatusId(),
                promo_code_id: getPromoCodeId(),
            },
            success: function (data) {
                orderItemsContainer.html(data.orderItems);
                totalOrderInfoContainer.html(data.totalOrderInfo);
                discountsContainer.html(data.discounts);
                bonusesContainer.html(data.bonuses);
                customerAddressContainer.html(data.customer_address)

            },
            error: function (e) {
                alert(e);
            }
        });
    };

    let listenPackaging = function () {
        $(document).on('change', '#package_id, #packaging_price', updateOrderInformation);
    };

    /* public */

    let init = function () {
        construct();
        //
        setActiveVariants();
        listenOfferRemove();
        listenLocationChange();
        listenExtraDiscountChange();
        listenChangeDeliveryType();
        listenChangeDeliveryTariff();
        listenProductSelectedInPopup();
        listenChangePaymentType();
        listenChangeOfferQuantity();
        listenChangeExtraDiscountType();
        listenVariantCheckBox();
        listenOrderSubmitButton();
        listenPackaging();
    };

    return {
        init: init
    };

})();

export default OrderDetail;
